(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    if (!window._collectionCartDrawerHookBound) {
      document.addEventListener('ajaxProduct:added', function() {
        if (window.theme && theme.miniCart) {
          theme.miniCart.generateCart();
          theme.miniCart.updateElements();
        }

        var toggleCart = document.querySelector('.js-toggle-cart');
        if (toggleCart) {
          var miniCartParent = toggleCart.closest('.js-mini-cart');
          if (miniCartParent && !miniCartParent.classList.contains('active')) {
            toggleCart.click();
            return;
          }
        }

        var miniCart = document.querySelector('.js-mini-cart');
        if (miniCart && !miniCart.classList.contains('active')) {
          miniCart.classList.add('active');
        }
      });

      window._collectionCartDrawerHookBound = true;
    }

    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              const slider = this.querySelector('.product-recommendations-slider');
              if (slider) slider.dataset.sliderInit = 'false';
              this.innerHTML = recommendations.innerHTML;
              this.initSlider();
            }

            if (html.querySelector('.product-recommendations-slider__item')) {
              this.classList.add('product-recommendations--loaded');
            }

            if (window.SPR && theme.review) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              }
            }
          })
          .catch(e => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 500px 0px' }).observe(this);
    }

    initProductCards() {
      const root = this;
      const run = () => {
        if (window.theme && typeof theme.initPlpProductGalleries === 'function') {
          theme.initPlpProductGalleries(root);
        }
      };

      if (window.theme && typeof theme.initPlpProductGalleries === 'function') {
        run();
      } else {
        window.addEventListener('load', run, { once: true });
      }
    }

    initSlider() {
      const slider = this.querySelector('.product-recommendations-slider');
      if (!slider || slider.dataset.sliderInit === 'true') return;

      const viewport = slider.querySelector('.product-recommendations-slider__viewport');
      const track = slider.querySelector('.product-recommendations-slider__track');
      const items = Array.from(slider.querySelectorAll('.product-recommendations-slider__item'));
      const prevBtn = slider.querySelector('.product-recommendations-slider__nav--prev');
      const nextBtn = slider.querySelector('.product-recommendations-slider__nav--next');
      const dotsWrap = slider.querySelector('.product-recommendations-slider__dots');

      if (!viewport || !track || !items.length || !prevBtn || !nextBtn) return;

      slider.dataset.sliderInit = 'true';

      let currentPage = 0;
      let perPage = getPerPage();
      let totalPages = getTotalPages();

      function getPerPage() {
        const isMobile = window.innerWidth < 750;

        if (isMobile) {
          return slider.classList.contains('columns-mobile-12') ? 1 : 2;
        }

        if (slider.classList.contains('columns-desktop-6')) return 2;
        if (slider.classList.contains('columns-desktop-4')) return 3;
        return 4;
      }

      function getTotalPages() {
        return Math.max(1, Math.ceil(items.length / perPage));
      }

      function updateDots() {
        if (!dotsWrap) return;

        dotsWrap.innerHTML = '';

        for (let i = 0; i < totalPages; i++) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'product-recommendations-slider__dot' + (i === currentPage ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Ir al slide ' + (i + 1));
          dot.addEventListener('click', () => {
            currentPage = i;
            updateSlider();
          });
          dotsWrap.appendChild(dot);
        }
      }

      function updateButtons() {
        if (totalPages <= 1) {
          prevBtn.style.display = 'none';
          nextBtn.style.display = 'none';
          dotsWrap.style.display = 'none';
          return;
        }

        prevBtn.style.display = '';
        nextBtn.style.display = '';
        dotsWrap.style.display = 'flex';

        prevBtn.disabled = currentPage === 0;
        nextBtn.disabled = currentPage >= totalPages - 1;
      }

      function updateSlider() {
        const translate = -(100 / perPage) * (currentPage * perPage);
        track.style.transform = `translateX(${translate}%)`;
        updateDots();
        updateButtons();
      }

      function recalc() {
        perPage = getPerPage();
        totalPages = getTotalPages();
        if (currentPage > totalPages - 1) currentPage = totalPages - 1;
        updateSlider();
      }

      prevBtn.addEventListener('click', () => {
        if (currentPage > 0) {
          currentPage--;
          updateSlider();
        }
      });

      nextBtn.addEventListener('click', () => {
        if (currentPage < totalPages - 1) {
          currentPage++;
          updateSlider();
        }
      });

      window.addEventListener('resize', recalc);

      const bindDrag = () => {
        let startX = 0;
        let startY = 0;
        let dragging = false;
        let isHorizontal = false;

        const getBaseTranslate = () => -(100 / perPage) * (currentPage * perPage);

        const onStart = (clientX, clientY) => {
          startX = clientX;
          startY = clientY;
          dragging = true;
          isHorizontal = false;
          viewport.classList.add('is-dragging');
          track.style.transition = 'none';
        };

        const onMove = (clientX) => {
          if (!dragging) return;
          const delta = clientX - startX;
          const base = getBaseTranslate();
          track.style.transform = `translateX(calc(${base}% + ${delta}px))`;
        };

        const onEnd = (clientX) => {
          if (!dragging) return;
          dragging = false;
          viewport.classList.remove('is-dragging');
          track.style.transition = '';
          const delta = clientX - startX;
          const threshold = Math.max(40, viewport.offsetWidth * 0.12);

          if (delta < -threshold && currentPage < totalPages - 1) {
            currentPage++;
          } else if (delta > threshold && currentPage > 0) {
            currentPage--;
          }

          updateSlider();
        };

        viewport.addEventListener(
          'touchstart',
          (e) => {
            if (e.touches.length !== 1) return;
            onStart(e.touches[0].clientX, e.touches[0].clientY);
          },
          { passive: true }
        );

        viewport.addEventListener(
          'touchmove',
          (e) => {
            if (!dragging || e.touches.length !== 1) return;
            const dx = e.touches[0].clientX - startX;
            const dy = e.touches[0].clientY - startY;

            if (!isHorizontal) {
              if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
              isHorizontal = Math.abs(dx) > Math.abs(dy);
            }

            if (isHorizontal) {
              e.preventDefault();
              onMove(e.touches[0].clientX);
            }
          },
          { passive: false }
        );

        viewport.addEventListener(
          'touchend',
          (e) => {
            if (!isHorizontal) {
              dragging = false;
              viewport.classList.remove('is-dragging');
              track.style.transition = '';
              return;
            }
            const x = e.changedTouches[0] ? e.changedTouches[0].clientX : startX;
            onEnd(x);
            isHorizontal = false;
          },
          { passive: true }
        );

        viewport.addEventListener('mousedown', (e) => {
          if (e.button !== 0) return;
          e.preventDefault();
          onStart(e.clientX, e.clientY);

          const onMouseMove = (ev) => onMove(ev.clientX);
          const onMouseUp = (ev) => {
            onEnd(ev.clientX);
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
          };

          document.addEventListener('mousemove', onMouseMove);
          document.addEventListener('mouseup', onMouseUp);
        });
      };

      bindDrag();
      recalc();
      this.initProductCards();
    }

    connectedCallback() {
      if (this.querySelector('.product-recommendations-slider__item')) {
        this.initSlider();
      }
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    
  var initPhotoSwipeFromDOM = function (gallerySelector) {
    // parse slide data (url, title, size ...) from DOM elements
    // (children of gallerySelector)
    var parseThumbnailElements = function (el) {
      var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
        numNodes = thumbElements.length,
        items = [],
        figureEl,
        linkEl,
        size,
        item;

      for (var i = 0; i < numNodes; i++) {
        figureEl = thumbElements[i]; // <figure> element
        // include only element nodes
        if (figureEl.nodeType !== 1) {
          continue;
        }

        linkEl = figureEl.children[0]; // <a> element
        if (linkEl.getAttribute('data-size')) {
          size = linkEl.getAttribute('data-size').split('x');
        } else {
          size = [];
        }

        // create slide object
        item = {
          src: linkEl.getAttribute('href'),
          w: parseInt(size[0], 10),
          h: parseInt(size[1], 10),
        };

        if (figureEl.children.length > 1) {
          // <figcaption> content
          item.title = figureEl.children[1].innerHTML;
        }

        if (linkEl.children.length > 0) {
          // thumbnail element, retrieving thumbnail url
          item.msrc = linkEl.children[0].getAttribute('src');
        }

        item.el = figureEl; // save link to element for getThumbBoundsFn
        items.push(item);
      }

      return items;
    };

    // find nearest parent element
    var closest = function closest(el, fn) {
      return el && (fn(el) ? el : closest(el.parentNode, fn));
    };

    // triggers when user clicks on thumbnail
    var onThumbnailsClick = function (e) {
      e = e || window.event;
      e.preventDefault ? e.preventDefault() : (e.returnValue = false);

      var eTarget = e.target || e.srcElement;

      // find root element of slide
      var clickedListItem = closest(eTarget, function (el) {
        return el.tagName && el.tagName.toUpperCase() === 'FIGURE';
      });

      if (!clickedListItem) {
        return;
      }

      // find index of clicked item by looping through all child nodes
      // alternatively, you may define index via data- attribute
      var clickedGallery = clickedListItem.parentNode,
        childNodes = clickedListItem.parentNode.childNodes,
        numChildNodes = childNodes.length,
        nodeIndex = 0,
        index;

      for (var i = 0; i < numChildNodes; i++) {
        if (childNodes[i].nodeType !== 1) {
          continue;
        }

        if (childNodes[i] === clickedListItem) {
          index = nodeIndex;
          break;
        }
        nodeIndex++;
      }

      if (index >= 0) {
        // open PhotoSwipe if valid index found
        openPhotoSwipe(index, clickedGallery);
      }
      return false;
    };

    // parse picture index and gallery index from URL (#&pid=1&gid=2)
    var photoswipeParseHash = function () {
      var hash = window.location.hash.substring(1),
        params = {};

      if (hash.length < 5) {
        return params;
      }

      var vars = hash.split('&');
      for (var i = 0; i < vars.length; i++) {
        if (!vars[i]) {
          continue;
        }
        var pair = vars[i].split('=');
        if (pair.length < 2) {
          continue;
        }
        params[pair[0]] = pair[1];
      }

      if (params.gid) {
        params.gid = parseInt(params.gid, 10);
      }

      return params;
    };

    var openPhotoSwipe = function (index, galleryElement, disableAnimation, fromURL) {
      var pswpElement = document.querySelectorAll('.pswp')[0],
        gallery,
        options,
        items;

      items = parseThumbnailElements(galleryElement);

      // define options (if needed)
      options = {
        maxSpreadZoom: 1,
        bgOpacity: 0.7,
        zoomEl: true,
        history: false,
        pinchToClose: false,
        closeOnScroll: false,

        // define gallery index (for URL)
        galleryUID: galleryElement.getAttribute('data-pswp-uid'),
      };

      // PhotoSwipe opened from URL
      if (fromURL) {
        if (options.galleryPIDs) {
          // parse real index when custom PIDs are used
          // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
          for (var j = 0; j < items.length; j++) {
            if (items[j].pid == index) {
              options.index = j;
              break;
            }
          }
        } else {
          // in URL indexes start from 1
          options.index = parseInt(index, 10) - 1;
        }
      } else {
        options.index = parseInt(index, 10);
      }

      // exit if index not found
      if (isNaN(options.index)) {
        return;
      }

      if (disableAnimation) {
        options.showAnimationDuration = 0;
      }

      // Pass data to PhotoSwipe and initialize it
      gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
      gallery.init();
    };

    // loop through all gallery elements and bind events
    var galleryElements = document.querySelectorAll(gallerySelector);

    for (var i = 0, l = galleryElements.length; i < l; i++) {
      galleryElements[i].setAttribute('data-pswp-uid', i + 1);
      galleryElements[i].onclick = onThumbnailsClick;
    }

    // Parse URL and open gallery if it contains #&pid=3&gid=1
    var hashData = photoswipeParseHash();
    if (hashData.pid && hashData.gid) {
      openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
    }
  };

  // execute above function
  initPhotoSwipeFromDOM('.my-gallery');

  } catch(e) { console.error(e); }
})();
})();
